export enum ProgramStudiowStudentaStatus {
  Student = 1,
  Absolwent,
  Skreslony,
}
